// extracted by mini-css-extract-plugin
export var compactFilters = "_fe-4";
export var detailImage = "_fe-1";
export var dropdownContainer = "_fe-2";
export var imageContainer = "_fe-0";
export var selectedCard = "_fe-3";